import ControlSliderArrows from './ControlSliderArrows'

export default ControlSliderArrows
